import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconImageAlt = (props) => (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: [_jsx("path", { d: "M19 3H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM5 19V5h14l.002 14H5z" }), _jsx("path", { d: "m10 14-1-1-3 4h12l-5-7z" })] }));
const Memo = memo(SvgIconImageAlt);
export default Memo;
//# sourceMappingURL=IconImageAlt.js.map